import { getPlantEmoji, getPlantImage } from '@/lib/plantEmojis';

interface PlantIconProps {
  name: string;
  className?: string;
}

export function PlantIcon({ name, className = 'text-lg' }: PlantIconProps) {
  const image = getPlantImage(name);

  if (image) {
    return <img src={image} alt={name} className="inline-block h-5 w-5 object-contain" />;
  }

  return <span className={className}>{getPlantEmoji(name)}</span>;
}
